export default {
  computed: {
    cancelable() {
      return (this.$store.getters.isCancelable(this.objectNumber));
    },
  },
  watch: {
    cancelable: {
      immediate: true,
      handler(val) {
        this.dataLayerPush( // gtm dataLayer push cancelable info
          {
            event: 'cancelable',
            cancelable: val,
          },
        );
      },
    },
  },
};
